import { render, staticRenderFns } from "./SputumCulture.vue?vue&type=template&id=16c1389e&scoped=true"
import script from "./SputumCulture.vue?vue&type=script&lang=js"
export * from "./SputumCulture.vue?vue&type=script&lang=js"
import style0 from "./SputumCulture.vue?vue&type=style&index=0&id=16c1389e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c1389e",
  null
  
)

export default component.exports